import { render, staticRenderFns } from "./OrderFollowerInformation.vue?vue&type=template&id=324384cc&scoped=true"
import script from "./OrderFollowerInformation.vue?vue&type=script&lang=js"
export * from "./OrderFollowerInformation.vue?vue&type=script&lang=js"
import style0 from "./OrderFollowerInformation.vue?vue&type=style&index=0&id=324384cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324384cc",
  null
  
)

export default component.exports